import React from 'react';
import { connect } from 'react-redux';
import {
  Col,
  Row,
  Modal,
  Glyphicon,
  Tooltip, OverlayTrigger,
} from 'react-bootstrap';
import {
  Button,
} from '../../../form/FormControls.jsx';
import RoleConfigFilter from '../../../auth/RoleConfigFilter.jsx';
import FancyInput from '@/component/form/numinput/index.jsx';
import { List, Map } from 'immutable';
import { Currency } from '../../../../consts/currency.jsx';
import { handleFormChanged } from '@/store/allaround.store.js';
import ExpensesList from './ExpensesElement.jsx';
import { getSimpleListWrapper } from '../../../dict/simple/SimpleWrapper';
import {
  updateTransportExpense,
  addTransportExpense,
  removeTransportExpense,
  updateDealExpense,
  addDealExpense,
  removeDealExpense,
  updateFobNetback }
  from '../store/deal.store';
import { formatNumber, formatNumberZeroIfNull, formatCurrency } from '../elements/BaseElement';

import {
  FREIGHT_EXPENSES_TYPE,
  calcFreightActual,
  getFreight,
  calcAtomBLCountByAllLinks,
  calcTransportBLCountByAllLinks,
  calcEstimated,
  calcActual,
  validate,
  calcActualSPProfitability,
  calcActualTProfitability,
  calcEstimatedSPProfitability,
  calcEstimatedTProfitability,
  getCurrencyValue,
  getPriceValue,
  getLinksOverallBL,
  PRODUCT_EXPENSES_TYPE }
  from '../expenses/ExpensesUtils';


import {
  REF_NAME as EXPENSESTYPE_REF_NAME,
  REF_PATH as EXPENSESTYPE_REF_PATH }
  from '../../../dict/complex/expensestype/Const';

import {
  REF_NAME as DELIVERY_TERM_REF_NAME,
  REF_PATH as DELIVERY_TERM_REF_PATH }
  from '../../../dict/simple/deliveryterm/Const';

import {
  REF_NAME as BUYER_TERM_REF_NAME,
  REF_PATH as BUYER_TERM_REF_PATH }
  from '../../../dict/simple/buyer/Const';

import {
  REF_NAME as SUPPLIER_TERM_REF_NAME,
  REF_PATH as SUPPLIER_TERM_REF_PATH }
  from '../../../dict/simple/supplier/Const';

import { putPLError, clearPLError, putPLTotal } from '../store/pltab.store';

const estimatedCurrencyStyle = { paddingRight: '18px' };
const actualCurrencyStyle = { paddingRight: '14px' };

class Expenses extends React.Component {
  constructor(props) {
    super(props);
    this.handleChangeEstimated = this.handleChangeEstimated.bind(this);
    this.handleChangeActual = this.handleChangeActual.bind(this);
    this.handleExpensesTypeAndActualChange = this.handleExpensesTypeAndActualChange.bind(this);
    this.handleEstimateCurrencyChange = this.handleEstimateCurrencyChange.bind(this);
    this.handleActualCurrencyChange = this.handleActualCurrencyChange.bind(this);
    this.handleRowDelete = this.handleRowDelete.bind(this);
    this.handleSummTypeChange = this.handleSummTypeChange.bind(this);
    this.handleDebitChange = this.handleDebitChange.bind(this);
    this.handleOriginChange = this.handleOriginChange.bind(this);
    this.addExpenses = this.addExpenses.bind(this);
    this.validate = this.validate.bind(this);
    this.calcActualProfitability = this.calcActualProfitability.bind(this);
    this.calcEstimatedProfitability = this.calcEstimatedProfitability.bind(this);
    this.calcExcludeExpenseTypes = this.calcExcludeExpenseTypes.bind(this);
    this.getExpensesTypeName = this.getExpensesTypeName.bind(this);
    this.expensePreprocessor = this.expensePreprocessor.bind(this);
    this.init = this.init.bind(this);
    this.openModalDelete = this.openModalDelete.bind(this);
    this.closeModalDelete = this.closeModalDelete.bind(this);
    this.yesButtonDelete = this.yesButtonDelete.bind(this);
    this.editFobEstimate = this.editFobEstimate.bind(this);
    this.editFobComplete = this.editFobComplete.bind(this);
    this.handleFreightExpenseCreation = this.handleFreightExpenseCreation.bind(this);
    this.state = {};
  }
  componentWillMount() {
    this.init(this.props);
  }
  componentDidMount() {
    // pre-loading
    getSimpleListWrapper(EXPENSESTYPE_REF_NAME, EXPENSESTYPE_REF_PATH);
    getSimpleListWrapper(DELIVERY_TERM_REF_NAME, DELIVERY_TERM_REF_PATH);
    getSimpleListWrapper(BUYER_TERM_REF_NAME, BUYER_TERM_REF_PATH);
    getSimpleListWrapper(SUPPLIER_TERM_REF_NAME, SUPPLIER_TERM_REF_PATH);
  }

  componentWillReceiveProps(props) {
    this.init(props);
  }

  getType(value) {
    return Number.parseInt(value, 10);
  }

  getExpensesTypeName(props, expensesType) {
    const expensesTypeName = props.expensesTypes
      ? props.expensesTypes
        .find(et => et.get('id') == expensesType, this, new Map())
        .get('name')
      : undefined;
    return expensesTypeName;
  }

  getExpensesType(props, expensesTypeName) {
    const expensesType = props.expensesTypes
      ? props.expensesTypes
        .find(et => et.get('name').toLowerCase() == expensesTypeName, this, new Map())
        .get('id')
      : undefined;
    return expensesType;
  }

  handleFreightExpenseCreation(freightExpenseIdx, props) {
    if (freightExpenseIdx === -1 && !this.state.freightExpenseExist && calcTransportBLCountByAllLinks(props.deal)) {
      this.setState({ freightExpenseExist: true });
      this.addExpenses({ value:
          this.getExpensesType(props, FREIGHT_EXPENSES_TYPE) }, true, props);
    }
  }

  init(props) {
    if (props.usdRates && !this.state.usdRates) {
      this.setState({ usdRates:
        props.usdRates.map(elem => elem.set('value', elem.get('currency'))) });
    }

    let expenses = new List();


    if (props.dealType == 'transport') {
      const transportExpenses = props.deal.get('expenses', new List());
      const freightExpenseIdx = transportExpenses.findIndex(expense =>
        (expense.get('expensesTypeName', '') || '').toLowerCase() == FREIGHT_EXPENSES_TYPE);
      // freight for transport
      if (props.deal.get('freightAmount', 0) > 0 && !props.expensesTypes.isEmpty()) {
        this.handleFreightExpenseCreation(freightExpenseIdx, props);
      } else if (freightExpenseIdx > -1
          && transportExpenses.get(freightExpenseIdx).get('estimate') <= 0) {
        this.setState({ freightExpenseExist: false });
        this.props.removeExpense(this.props.idx, freightExpenseIdx);
      }
    } else {
      const productExpenses = props.product.get('expenses', new List());
      const freightExpenseIdx = productExpenses.findIndex(expense =>
        (expense.get('expensesTypeName', '') || '').toLowerCase() == FREIGHT_EXPENSES_TYPE);
      const dealLinks = props.product.get('saleLink', new List())
        .concat(props.product.get('purchaseLink', new List())).filter(l => !l.get('hidden'));
      if (dealLinks.some(l => l.get('freightAmount', 0) > 0)) {
        this.handleFreightExpenseCreation(freightExpenseIdx, props);
      } else if (freightExpenseIdx > -1
        && productExpenses.get(freightExpenseIdx).get('estimate') <= 0) {
        if ((props.dealType == 'sale' && productExpenses.get(freightExpenseIdx)
          .get('autoCreated'))
            || props.dealType == 'purchase') {
          this.setState({ freightExpenseExist: false });
          this.props.removeExpense(this.props.idx, freightExpenseIdx);
        }
      }
    }

    if (props.product.get('expenses') !== undefined) {
      props.product.get('expenses').forEach((data) => {
        expenses = expenses.push({
          id: data.get('id'),
          expensesTypeName: data.get('expensesTypeName'),
          expensesType: data.get('expensesType'),
          estimateCurrency: data.get('estimateCurrency'),
          estimateCurrencyRates: data.get('estimateCurrencyRates'),
          actualCurrency: data.get('actualCurrency'),
          estimate: data.get('estimate'),
          actual: data.get('actualWithBulk', data.get('actual')),
          summType: data.get('summType'),
          isDebit: data.get('isDebit'),
          dropDownWasShown: data.get('dropDownWasShown'),
          paymentExpense: data.get('paymentExpense'),
          autoCreated: data.get('autoCreated'),
          bulkExpense: data.get('bulkExpense'),
          freightOrigin: data.get('freightOrigin'),
        });
      });

      const getLinkedSaleEstimatedExpense = (l, expense) => {
        const saleId = l.get('saleId');
        if (saleId || saleId === 0) {
          const linkedSale = props.deals.get('sale', new List())
            .find(s => s.get('id') == saleId, this, new Map());
          const linkedSaleProduct = linkedSale.get('products', new List())
            .find(product => product.get('id') == l.get('saleProduct'), this, new Map());
          const saleFreight = linkedSaleProduct.get('expenses', new List())
            .find(exp => exp.get('expensesType') == expense.expensesType, this, new Map());
          return getCurrencyValue(saleFreight, 'estimate',
            'estimateCurrency', 'estimateCurrencyRates');
        }
        return 0.00;
      };

      expenses = expenses.map((expense) => {
        let estimatedFreightValue = 0.00;
        if (props.dealType == 'transport' && expense.expensesTypeName
          && expense.expensesTypeName.toLowerCase() == FREIGHT_EXPENSES_TYPE) {
          const salesWithEstimatedFreight = props.deal.get('links', new List())
            .filter(l => getLinkedSaleEstimatedExpense(l, expense));
          if (salesWithEstimatedFreight.size) {
            const firstFreightValue =
              getLinkedSaleEstimatedExpense(salesWithEstimatedFreight.get(0), expense);
            estimatedFreightValue = salesWithEstimatedFreight
              .reduce((sum, l) => sum + getLinkedSaleEstimatedExpense(l, expense), 0.00) /
              salesWithEstimatedFreight.size == firstFreightValue ? firstFreightValue : 'N/A';
          }

          // считаем actual
          const actual = calcFreightActual(
            props.product,
            props.dealType,
            props.deals ? props.deals.get('transport') : undefined);
          return { ...expense, actual, estimate: estimatedFreightValue };
        } else if (props.dealType != 'transport' && expense.expensesTypeName
          && expense.expensesTypeName.toLowerCase() == FREIGHT_EXPENSES_TYPE) {
          let estimate = expense.estimate;
          if (props.dealType == 'purchase') {
            estimate = '-';
          }
          const actual = Math.round(calcFreightActual(
            props.product,
            props.dealType,
            props.deals ? props.deals.get('transport') : undefined) * 100) / 100;
          const newExpense = { ...expense, actual, estimate };
          if (expense.estimateCurrency != Currency.DOLLAR && expense.estimateCurrencyRates) {
            const currencyRate = expense.estimateCurrencyRates
              .find(r => r.get('value') == expense.estimateCurrency);
            if (currencyRate) {
              newExpense.actual =
                Math.round(newExpense.actual / currencyRate.get('rate') * 100) / 100;
            }
          }
          return newExpense;
        }
        return expense;
      });
    }
    const billLandingQuantity =
      props.dealType == 'transport'
        ? calcTransportBLCountByAllLinks(props.product)
        : calcAtomBLCountByAllLinks(props.product);

    const errorsObject = this.validate(props,
      props.dealType == 'transport'
        ? expenses
        : undefined);
    const estimatedErrors = errorsObject ? errorsObject.estimatedErrors : [];
    const actualErrors = errorsObject ? errorsObject.actualErrors : [];
    if (actualErrors && actualErrors.length) {
      props.putPLError(props.product.get('id'), actualErrors[0]);
    } else {
      props.clearPLError(props.product.get('id'));
    }
    let expensesToCalculate = expenses.map(e => Object.assign({}, e));
    if (props.dealType == 'purchase') {
      expensesToCalculate = expensesToCalculate.filter(expense => expense.expensesTypeName
      && expense.expensesTypeName.toLowerCase() != FREIGHT_EXPENSES_TYPE);
    }
    const estimate = props.dealType == 'transport' ?
      calcEstimated(expensesToCalculate.filter(expense => expense.expensesTypeName
      && expense.expensesTypeName.toLowerCase() != FREIGHT_EXPENSES_TYPE))
      :
      calcEstimated(expensesToCalculate);

    expensesToCalculate = expensesToCalculate.push(props.deal.get('laytimeTotal', new List()));
    const actual = calcActual(expensesToCalculate, billLandingQuantity);

    const actualProfitabilityPT = this.calcActualProfitability(props, expensesToCalculate);
    const actualProfitabilityLS = actualProfitabilityPT * this.calcOverallBL(props);
    const estimatedProfitability = props.dealType == 'transport' ?
      this.calcEstimatedProfitability(props,
        expensesToCalculate.filter(expense => expense.expensesTypeName
          && expense.expensesTypeName.toLowerCase() != FREIGHT_EXPENSES_TYPE))
      :
      this.calcEstimatedProfitability(props, expensesToCalculate);
    const excludeExpenseTypes = this.calcExcludeExpenseTypes(expensesToCalculate);

    let hasTransportFreight = false;
    if (props.dealType == 'transport') {
      hasTransportFreight = props.deal.get('freightAmount', 0) > 0;
    } else {
      const dealLinks = props.product.get(`${props.dealType}Link`);
      if (dealLinks) {
        hasTransportFreight = dealLinks.filter(l => l.get('freightAmount') > 0).size > 0;
      }
    }
    this.setState({
      hasTransportFreight,
      expenses,
      estimate,
      actual,
      billLandingQuantity,
      estimatedErrors,
      actualErrors,
      actualProfitabilityPT,
      actualProfitabilityLS,
      estimatedProfitability,
      excludeExpenseTypes,
    });
    if (props.dealType == 'transport') {
      this.props.putPLTotal('deal', 'estimated',
        estimatedErrors && estimatedErrors.length ? 'N/A' : estimatedProfitability);
      this.props.putPLTotal('deal', 'actualLS',
        actualErrors && actualErrors.length ? 'N/A' : actualProfitabilityLS);
      this.props.putPLTotal('deal', 'actualPT',
        actualErrors && actualErrors.length ? 'N/A' : actualProfitabilityPT);
      this.props.putPLTotal('deal', 'bl', billLandingQuantity);
    }
  }

  expensePreprocessor(props, expenseIdx, values) {
    if (this.state.expenses) {
      let expense = this.state.expenses.get(expenseIdx);

      expense = { ...expense, ...values };

      if (expense.expensesTypeName
        && expense.expensesTypeName.toLowerCase() == FREIGHT_EXPENSES_TYPE
        && props.dealType == 'sale') {
        // считаем actual
        const actual = calcFreightActual(
          props.product,
          props.dealType,
          props.deals ? props.deals.get('transport') : undefined);

        const summType = 'PT';
        const isDebit = true;

        return { ...expense, actual, summType, isDebit };
      }
      return expense;
    }
    return undefined;
  }

  /* eslint-disable no-param-reassign */
  handleChangeEstimated(idx, estimate) {
    this.props.updateExpense(
      this.props.idx,
      idx,
      this.expensePreprocessor(this.props, idx, { estimate }),
    );
  }

  /* eslint-disable no-param-reassign */
  handleChangeActual(idx, actual) {
    this.props.updateExpense(
      this.props.idx,
      idx,
      this.expensePreprocessor(this.props, idx, { actual }),
    );
  }
  handleOriginChange(idx, freightOrigin) {
    this.props.updateExpense(
      this.props.idx,
      idx,
      this.expensePreprocessor(this.props, idx,
        { freightOrigin: freightOrigin ? freightOrigin.value : undefined }),
    );
  }

  /* eslint-disable no-param-reassign */
  handleExpensesTypeAndActualChange(idx, typeValue, actual) {
    const expense = this.expensePreprocessor(this.props, idx);
    if (expense) {
      const expensesType = typeValue != null ? typeValue.value : null;
      const expensesTypeName = this.getExpensesTypeName(this.props, expensesType);

      const changes = { expensesType, expensesTypeName };
      if (actual !== undefined) {
        changes.actual = actual;
      }
      this.props.updateExpense(
        this.props.idx,
        idx,
        this.expensePreprocessor(this.props, idx, changes),
      );
    }
  }

  /* eslint-disable no-param-reassign */
  handleEstimateCurrencyChange(idx, value) {
    if (value) {
      this.props.updateExpense(
        this.props.idx,
        idx,
        this.expensePreprocessor(this.props, idx,
          { estimateCurrency: value.currency, estimateCurrencyRates: value.rates }),
      );
    }
  }

  /* eslint-disable no-param-reassign */
  handleActualCurrencyChange(idx, value) {
    const expenses = this.state.expenses.set(
      idx,
      { ...this.state.expenses.get(idx, {}), actualCurrency: value },
    );
    this.setState({ ...this.state, expenses });
  }

  handleRowDelete(idx) {
    this.props.removeExpense(this.props.idx, idx);
  }

  handleSummTypeChange(idx, summType) {
    this.props.updateExpense(
      this.props.idx,
      idx,
      this.expensePreprocessor(this.props, idx, { summType }),
    );
  }

  handleDebitChange(idx, isDebit) {
    this.props.updateExpense(
      this.props.idx,
      idx,
      this.expensePreprocessor(this.props, idx, { isDebit }),
    );
  }

  addExpenses(expensesType, autoCreated = false, props = this.props) {
    const actualRates = (this.state.usdRates || new List())
      .map(r => r.set('value', r.get('currency')));
    const expense = {
      expensesType: expensesType.value,
      expensesTypeName: this.getExpensesTypeName(props, expensesType.value),
      actual: 0.0,
      estimate: 0.0,
      actualCurrency: Currency.DOLLAR,
      estimateCurrency: Currency.DOLLAR,
      estimateCurrencyRates: actualRates,
      actualCurrencyRates: actualRates,
      summType: 'PT',
      isDebit: true,
      autoCreated,
    };
    props.addExpense(props.idx, expense);
    props.handleFormChanged();
  }

  validate(props, expenses) {
    return validate(
      props.product,
      props.dealType,
      expenses,
      props.deals,
      props.deal,
      props.expensesTypes,
      props.deliveryTerms,
      props.buyers,
      props.suppliers,
    );
  }

  calcActualProfitability(props, expenses) {
    return props.dealType == 'transport'
      ? calcActualTProfitability(
        props.deal,
        props.deals,
        expenses)
      : calcActualSPProfitability(
        props.product,
        props.dealType,
        props.deals,
        expenses);
  }

  calcOverallBL(props) {
    return props.dealType == 'transport'
      ? getLinksOverallBL(props.deal, props.dealType)
      : getLinksOverallBL(props.product, props.dealType);
  }

  calcEstimatedProfitability(props, expenses) {
    return props.dealType == 'transport'
      ? calcEstimatedTProfitability(
        props.deal,
        props.dealType,
        props.deals,
        props.deliveryTerms,
        expenses)
      : calcEstimatedSPProfitability(
        props.product,
        props.dealType,
        props.deals,
        props.deliveryTerms,
        expenses);
  }

  calcExcludeExpenseTypes(expenses) {
    let excludeExpenseTypes = new Set();
    if (this.props.expensesTypes) {
      const contractPaymentId = this.props.expensesTypes.find(
        e => e.get('name').toLowerCase() == PRODUCT_EXPENSES_TYPE, this, new Map())
        .get('id');
      if (contractPaymentId !== undefined) {
        excludeExpenseTypes = excludeExpenseTypes.add(contractPaymentId);
      }
    }
    if (expenses && expenses.size > 0) {
      expenses.forEach((exp) => {
        excludeExpenseTypes = excludeExpenseTypes.add(exp.expensesType);
      });
    }
    if (this.props.hideFreightExpense) {
      const freightExpenseId = this.props.expensesTypes.find(
        e => e.get('name').toLowerCase() == FREIGHT_EXPENSES_TYPE, this, new Map())
        .get('id');
      excludeExpenseTypes = excludeExpenseTypes.add(freightExpenseId);
    }
    return excludeExpenseTypes;
  }

  formatEstimatedProfitability(errors = [], style) {
    return (
      errors.length > 0 ?
        <Col sm={2} xs={4} className="text-right" style={style} id="profitabilityEstimatedAtom">
           N/A
        </Col> :
        <Col sm={2} xs={4} className="text-right" style={style} id="profitabilityEstimatedAtom">
          {formatCurrency(this.state.currency)}
          {formatNumberZeroIfNull(this.state.estimatedProfitability, '0,0.00')}
        </Col>
    );
  }

  formatActualProfitability(errors = [], style) {
    return (
      errors.length > 0 ?
        <Col sm={5} xs={4} className="text-right" style={style} id="profitabilityActualAtom">
          <Col xs={11} style={{ padding: '0px' }}>
            N/A
          </Col>
          <Col xs={1} />
        </Col> :
        <Col sm={5} xs={4} className="text-right" style={style} id="profitabilityActualAtom">
          <Col xs={11} style={{ padding: '0px' }}>
            {`(${formatCurrency(this.state.currency)}
              ${formatNumberZeroIfNull(this.state.actualProfitabilityLS || 0, '0,0.00')})
            ${formatCurrency(this.state.currency)}
              ${formatNumberZeroIfNull(this.state.actualProfitabilityPT || 0, '0,0.00')}`}
          </Col>
          <Col xs={1} />
        </Col>
    );
  }

  openModalDelete(expenseIdx) {
    if (this.state.expenses.get(expenseIdx, {}).expensesType) {
      this.setState({ showModalDelete: true, expenseIdx });
    } else {
      this.handleRowDelete(expenseIdx);
    }
  }
  closeModalDelete() {
    this.setState({ showModalDelete: false, expenseIdx: null });
  }
  yesButtonDelete() {
    this.handleRowDelete(this.state.expenseIdx);
    this.setState({ showModalDelete: false, expenseIdx: null });
  }

  editFobEstimate() {
    this.setState({ editFob: true });
  }

  editFobComplete() {
    this.setState({ editFob: false });
  }

  fobNetback() {
    if (this.props.dealType == 'sale') {
      const productDeliveryTerm = this.props.product.get('deliveryTerm');
      const deliveryTermName = this.props.deliveryTerms
        .find(dt => dt.get('id') == productDeliveryTerm, this, new Map()).get('name');
      const transportType = this.props.product.get('transportType');

      const compositeProduct = this.props.products.size && this.props.products.get(this.props.idx);
      const toPurchaseLinks = compositeProduct.get('saleLink', new List());
      const freightExpense = this.state.expenses
        .find(expense => (expense.expensesTypeName || '').toLowerCase() == FREIGHT_EXPENSES_TYPE);
      let estimatedNetBackIsOk = false;
      let fobNetbackIsVisible = false;
      if (deliveryTermName == 'FOB' && transportType == 'BULK') {
        fobNetbackIsVisible = true;
        estimatedNetBackIsOk = true;
      }
      if (['CFR', 'CIF'].includes(deliveryTermName)
          && (!transportType || transportType == 'BULK')) {
        if (freightExpense && freightExpense.estimate) {
          fobNetbackIsVisible = true;
          estimatedNetBackIsOk = true;
        }
        if (freightExpense && freightExpense.actual) {
          fobNetbackIsVisible = true;
        }
      }
      if (fobNetbackIsVisible) {
        const isFixedPrice = compositeProduct.get('fixedPrice') === null
          || compositeProduct.get('fixedPrice');
        let fobEstimated = 0;
        let fobActual = 'N/A';
        if (isFixedPrice) {
          const productPrice = getPriceValue(compositeProduct);
          fobEstimated = (productPrice || 0) - (this.state.estimate || 0);

          if (!this.state.actualErrors.length) {
            let totalBl = 0;
            const priceValueAndBLProductSum = toPurchaseLinks.reduce((total, link) => {
              const linkedPurchase = this.props.purchases
                .find(p => p.get('id') == link.get('purchaseId'),
                  this, new Map());
              const linkedProduct = linkedPurchase.get('products', new List())
                .find(p => p.get('id') == link.get('purchaseProduct'), this, new Map());
              const linkBL = link.get('billLandingQuantity', 0);
              totalBl += linkBL;
              return total + (getPriceValue(linkedProduct) * linkBL);
            }, 0);
            fobActual = totalBl > 0 ?
              priceValueAndBLProductSum / totalBl + this.state.actualProfitabilityPT
              : 0;
          }
        }
        const userFobNetback = this.props.product.get('userFobNetback');
        return (
          <Row
            style={{
              marginLeft: '0px',
              marginRight: '0px',
              padding: '5px',
            }}
          >
            <Col sm={5} xs={4}>FOB Netback</Col>
            <Col
              sm={2}
              xs={4}
              className="text-right"
              style={{ ...estimatedCurrencyStyle, display: 'flex', padding: 0 }}
              id="sumEstimated"
            >
              <span
                style={{ display: userFobNetback && estimatedNetBackIsOk ?
                  'flex' : 'none', alignItems: 'center' }}
              >
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip>
                    Estimated netback was entered manually. Original value: {fobEstimated}
                    </Tooltip>
                  }
                >
                  <Glyphicon
                    glyph="info-sign"
                    style={{ width: '15px' }}
                  />
                </OverlayTrigger>
              </span>
              <span
                style={{
                  width: '100%',
                  textAlign: 'right',
                  display: this.state.editFob ? 'none' : 'block',
                }}
              >
                {!estimatedNetBackIsOk ? '' : formatCurrency(this.state.currency)}
                {!estimatedNetBackIsOk ? 'N/A'
                  : formatNumber(userFobNetback || fobEstimated, '0,0.00')}
              </span>
              <span
                style={{
                  display: this.state.editFob ? 'block' : 'none',
                }}
              >
                <FancyInput
                  className="form-control customColor"
                  currency={formatCurrency(this.state.currency)}
                  style={{
                    textAlign: 'right',
                    height: '30px',
                  }}
                  fraction={2}
                  thousand
                  type="number"
                  value={userFobNetback}
                  onChange={(e, val) => this.props.updateFobNetback(this.props.idx, val)}
                />
              </span>
              <Button
                id="editFobEstimate"
                bsStyle="link"
                disabled={this.props.disabled || !estimatedNetBackIsOk}
                className="btn-link-no-underline-on-hover"
                onClick={this.state.editFob ? this.editFobComplete : this.editFobEstimate}
                style={{ padding: 0, width: '25px', textAlign: 'center', fontSize: '10px' }}
              >
                <Glyphicon glyph={this.state.editFob ? 'ok' : 'pencil'} />
              </Button>
            </Col>
            <Col sm={5} xs={4} className="text-right" style={actualCurrencyStyle} id="sumActual">
              <Col xs={11} style={{ padding: '0px' }}>
                {isNaN(fobActual) ? '' : formatCurrency(this.state.currency)}
                {isNaN(fobActual) ? fobActual : formatNumber(fobActual, '0,0.00')}
              </Col>
              <Col xs={1} />
            </Col>
          </Row>
        );
      }
      return '';
    }
    return '';
  }

  render() {
    let title;
    if (this.props.dealType == 'purchase') {
      title = 'Purchase costs';
    } else if (this.props.dealType == 'sale') {
      title = 'Sale costs';
    } else {
      title = 'Shipping costs';
    }
    const expensesId = `expenseFieldSet${this.props.dealType == 'transport' ?
      '' : `${this.props.idx}`}`;
    return (
      <Row style={this.props.style} id={expensesId} className="expenses-block">
        <Modal bsSize="small" show={this.state.showModalDelete} onHide={this.closeModalDelete} >
          <Modal.Body>
            Are you sure you want to delete the expense?
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={this.yesButtonDelete}>Yes</Button>
            <Button onClick={this.closeModalDelete}>No</Button>
          </Modal.Footer>
        </Modal>
        <div
          className={'expenses-header'}
          style={{
            borderBottom: '1px lightgray #dfdfdf',
          }}
        >
          <Col
            smHidden mdHidden lgHidden xs={10}
          >
            Estimated {title}
          </Col>
          <Col
            sm={5} xsHidden
          >
            {title}
          </Col>
          <Col
            sm={2}
            xsHidden
          >
            Estimated
          </Col>
          <Col sm={3} xsHidden>
              Actual
          </Col>
          <Col xs={2}>
            <Button
              id="addNewExpensesBtn"
              bsStyle="primary"
              disabled={this.props.disabled}
              style={{ padding: '4px 12px' }}
              onClick={() => this.addExpenses({})}
            >
                Add
            </Button>
          </Col>
        </div>
        <ExpensesList
          hideFreightExpense={this.props.hideFreightExpense}
          data={this.state.expenses}
          hasTransportFreight={this.state.hasTransportFreight}
          excludeExpenseTypes={this.state.excludeExpenseTypes}
          laytimeTotal={this.props.deal.get('laytimeTotal')}
          prefix={this.props.prefix}
          billLandingQuantity={this.state.billLandingQuantity}
          onExpensesTypeAndActualChange={this.handleExpensesTypeAndActualChange}
          onEstimateCurrencyChange={this.handleEstimateCurrencyChange}
          onActualCurrencyChange={this.handleActualCurrencyChange}
          onChangeEstimated={this.handleChangeEstimated}
          onChangeActual={this.handleChangeActual}
          onDeleteRow={this.openModalDelete}
          onSummTypeChange={this.handleSummTypeChange}
          onDebitChange={this.handleDebitChange}
          disabled={this.props.disabled}
          onOriginChange={this.handleOriginChange}
        />


        <Row
          style={{
            marginLeft: '0px',
            marginRight: '0px',
            padding: '5px',
          }}
        >
          <Col sm={5} xs={4}>Total Cost</Col>
          <Col sm={2} xs={4}className="text-right" style={estimatedCurrencyStyle} id="sumEstimated">
            {formatCurrency(this.state.currency)}
            {formatNumber(this.state.estimate, '0,0.00')}
          </Col>
          <Col sm={5} xs={4}className="text-right" style={actualCurrencyStyle} id="sumActual">
            <Col xs={11} style={{ padding: '0px' }}>
              {formatCurrency(this.state.currency)}
              {formatNumber(this.state.actual, '0,0.00')}
            </Col>
            <Col xs={1} />
          </Col>
        </Row>
        {this.fobNetback()}
        <Row
          style={{
            marginLeft: '0px',
            marginRight: '0px',
            padding: '5px',
          }}
        >
          <RoleConfigFilter permissions={['viewProfitability']}>
            <div>
              <Col sm={5} xs={4}>{this.props.dealType == 'transport' || (this.props.products &&
                this.props.products.filter(p => !p.get('hidden')).size == 1) ?
                'Deal profitability' : 'Profitability'}</Col>
              {this.formatEstimatedProfitability(
                this.state.estimatedErrors, estimatedCurrencyStyle)}
              {this.formatActualProfitability(
                this.state.actualErrors, actualCurrencyStyle)}
            </div>
          </RoleConfigFilter>
        </Row>

      </Row>);
  }
}

Expenses.propTypes = {
  idx: React.PropTypes.number,
  style: React.PropTypes.object,
  deal: React.PropTypes.object,
  deals: React.PropTypes.object,
  product: React.PropTypes.object,
  products: React.PropTypes.object,
  prefix: React.PropTypes.string,
  dealType: React.PropTypes.string,
  updateExpense: React.PropTypes.func,
  addExpense: React.PropTypes.func,
  removeExpense: React.PropTypes.func,
  usdRates: React.PropTypes.object,
  handleFormChanged: React.PropTypes.func,
  filterTransportsForProduct: React.PropTypes.func,
  expensesTypes: React.PropTypes.object,
  disabled: React.PropTypes.bool,
  hideFreightExpense: React.PropTypes.bool,
  purchases: React.PropTypes.object,
  updateFobNetback: React.PropTypes.func,
  deliveryTerms: React.PropTypes.object,
  putPLTotal: React.PropTypes.func,
};

export default connect(
  (state, props) => ({
    product: props.dealType == 'transport'
      ? state.getIn(['data', 'deals', 'deal'], new Map())
      : state.getIn(['data', 'deals', 'deal', 'products', props.idx], new Map()),
    products: state.getIn(['data', 'deals', 'deal', 'products'], new List()),
    deal: state.getIn(['data', 'deals', 'deal'], new Map()),
    deals: state.getIn(['data', 'deals', 'list'], new Map()),
    expensesTypes: state.getIn(['references', 'simple', EXPENSESTYPE_REF_PATH], new List()),
    deliveryTerms: state.getIn(['references', 'simple', DELIVERY_TERM_REF_PATH], new List()),
    buyers: state.getIn(['references', 'simple', BUYER_TERM_REF_PATH], new List()),
    suppliers: state.getIn(['references', 'simple', SUPPLIER_TERM_REF_PATH], new List()),
    usdRates: state.getIn(['data', 'currencies', 'USD', 'rates'], new List()),
    purchases: state.getIn(['data', 'deals', 'list', 'purchase'], new List()),
  }),
  (dispatch, props) => ({
    updateExpense(productIdx, expenseIdx, expense) {
      if (props.dealType == 'transport') {
        updateTransportExpense(dispatch, expenseIdx, expense);
      } else {
        updateDealExpense(dispatch, productIdx, expenseIdx, expense);
      }
    },
    updateFobNetback(productIdx, value) {
      updateFobNetback(dispatch, productIdx, value);
    },
    addExpense(productIdx, expense) {
      if (props.dealType == 'transport') {
        addTransportExpense(dispatch, expense);
      } else {
        addDealExpense(dispatch, productIdx, expense);
      }
    },
    removeExpense(productIdx, expenseIdx) {
      if (props.dealType == 'transport') {
        removeTransportExpense(dispatch, expenseIdx);
      } else {
        removeDealExpense(dispatch, productIdx, expenseIdx);
      }
    },
    handleFormChanged() {
      handleFormChanged(dispatch);
    },
    putPLError(elemId, message) {
      putPLError(dispatch, elemId, message);
    },
    clearPLError(elemId) {
      clearPLError(dispatch, elemId);
    },
    putPLTotal(elementId, totalType, value) {
      putPLTotal(dispatch, elementId, totalType, value);
    },
  }),
)(Expenses);
